import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

class CollapsiblesGroup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      indexToShow: -1,
    };
  }

  handleClick(index) {
    if (this.state.indexToShow === index) {
      this.setState({ indexToShow: -1 });
    } else {
      this.setState({ indexToShow: index });
    }
  }

  render() {
    const { collapsibles, isMobile } = this.props;
    const suffix = isMobile ? '-mobile' : '-desktop';
    return (
      <div id={`accordion${suffix}`}>
        {collapsibles.map((collapsibleItem, index) => (
          <div key={index}>
            <div className="border-0 p-0" id={`heading${index}${suffix}`}
                 onClick={this.handleClick.bind(this, index)}>
              <div className={`collapsed ${collapsibleItem.titleClass}`} data-toggle="collapse"
                   data-target={`#collapse${index}${suffix}`} aria-expanded="false"
                   aria-controls={`collapse${index}${suffix}`} role="button">
                {collapsibleItem.title}
                {this.state.indexToShow === index ? <i className="fa fa-angle-up ml-2"></i> :
                  <i className="fa fa-angle-down ml-2"></i>}
              </div>
            </div>
            <div id={`collapse${index}${suffix}`} className="collapse"
                 aria-labelledby={`heading${index}${suffix}`}
                 data-parent={`#accordion${suffix}`}>
              <div>
                {collapsibleItem.content}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

CollapsiblesGroup.propTypes = {
  collapsibles: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    titleClass: PropTypes.string,
    content: PropTypes.element.isRequired,
  })).isRequired,
  isMobile: PropTypes.bool,
};

export default CollapsiblesGroup;



// WEBPACK FOOTER //
// ./src/Nav/CollapsiblesGroup.js